import EmployeeDashboardWrapper from "components/layouts/EmployeeDashboardWrapper"
import DefBreadcrumb from "components/ui/breadcrumb/DefBreadcrumb"
import Card from "components/ui/card/Card"
import Chart from "components/ui/chart/PieChart"
import DateRange from "components/ui/date/DateRange"
import React, { useState } from "react"
import useGetDashboard from "utils/api/cms/queries/hooks/useGetDashboard"
import { getCMSSegments } from "utils/helper"
import { DashboardData } from "utils/api/cms/types"
import { createColumnHelper } from "@tanstack/react-table"
import ReactTable from "components/ui/react-table/ReactTable"

const Dashboard: React.FC = () => {
  const formatter = new Intl.NumberFormat("id-ID")
  const segments = getCMSSegments()
  const currentHour = new Date().getHours()
  let greeting: string
  const formatDate = (date: Date) => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };
  const today = formatDate(new Date());

  const [startDate, setStartDate] = useState<string>(today);
  const [endDate, setEndDate] = useState<string>(today);

  const { data: dashboard } = useGetDashboard(startDate, endDate);
  const failedPayment = dashboard?.data?.failed
  const pendingPayment = dashboard?.data?.pending
  const successPayment = dashboard?.data?.sold
  const paymentData = [
    pendingPayment ?? 0,
    successPayment ?? 0,
    failedPayment ?? 0,
  ]

  const handleDateChange = (start: string, end: string) => {
    setStartDate(start)
    setEndDate(end)
  }

  const partnersColHelper =
    createColumnHelper<DashboardData["partnership"][number]>()

  const partnersColumns = [
    partnersColHelper.accessor("full_name", {
      id: "full_name",
      header: "Nama",
      cell: (info) => info.getValue(),
    }),
    partnersColHelper.accessor("courses_count", {
      id: "total",
      header: "Jumlah Kelas",
      cell: (info) => info.getValue(),
    }),
  ]

  const topColHelper = createColumnHelper<DashboardData["top"][number]>()
  const topColumns = [
    topColHelper.accessor("title", {
      id: "title",
      header: "Judul Kelas",
      cell: (info) => info.getValue(),
    }),
    topColHelper.accessor("price", {
      header: () => "Original Price",
      cell: (props) => (
        <dl className="max-w-md text-white divide-y divide-gray-200">
          {`${props.getValue().currency_text
            } ${props.getValue().master_price_text}`}
        </dl>
      ),
    }),
    topColHelper.accessor("price", {
      header: () => "Discounted Price",
      cell: (props) => (
        <dl className="max-w-md text-white divide-y divide-gray-200">
          {`${props.getValue().currency_text
            } ${props.getValue().current_price_text}`}
        </dl>
      ),
    }),
    topColHelper.accessor("success_transactions", {
      id: "success_transactions",
      header: "Jumlah Transaksi",
      cell: (info) => info.getValue(),
    }),
  ]

  if (currentHour < 11) {
    greeting = "Pagi"
  } else if (currentHour < 15) {
    greeting = "Siang"
  } else {
    greeting = "Malam"
  }

  return (
    <EmployeeDashboardWrapper>
      <DefBreadcrumb
        segments={segments}
        prefix="cms"
      />
      <h2 className="text-xl text-primary font-semibold leading-loose tracking-wide mt-3 mb-3">
        Selamat {greeting}
      </h2>
      <DateRange onDateChange={handleDateChange} />
      <div className="grid lg:grid-cols-4 gap-5 mt-5">
        <Card
          title="Jumlah Course"
          total={dashboard?.data?.courses}
        />
        <Card
          title="Jumlah Terjual"
          total={dashboard?.data.sold}
        />
        <Card
          title="Jumlah Partnership"
          total={dashboard?.data.partner}
        />
        <Card
          title="Jumlah Pendapatan"
          rupiah={`Rp. ${formatter.format(Number(dashboard?.data.revenue))}`}
        />
      </div>
      <div className="mt-20">
        <div className="grid grid-cols-2 gap-5">
          <div>
            <h3 className="text-lg text-primary font-semibold mb-5">
              Grafik Transaksi
            </h3>
            <Chart coursesData={paymentData} />
          </div>

          <div>
            <h3 className="text-lg text-primary font-semibold mb-5">
              Detail Partnership
            </h3>
            <ReactTable
              columns={partnersColumns}
              data={dashboard?.data.partnership ?? []}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 gap-5 mb-20">
          <div>
            <h3 className="text-lg text-primary font-semibold mt-10 mb-5">
              Top 5 Kelas Terlaris
            </h3>
            <ReactTable
              columns={topColumns}
              data={dashboard?.data.top ?? []}
            />
          </div>
        </div>
      </div>
    </EmployeeDashboardWrapper>
  )
}

export default Dashboard
